<template>
  <div>
   <div>
    <bannerView></bannerView></div>
    <!-- services -->
    <!-- <div class="services animate__rubberBand">
      <div class="container">
        <div class="ser-wthree">
          <div
            class="services-agileinfo"
            style="width: 100%;"
          >
            <index-products></index-products>
            <div class="clearfix" ></div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- //services -->
<!--  
    <div class="reservation-info animate__bounceInDown">
      <div class="reservation">
        <div class="container">
          <div class="col-md-8 book-reservation">
            <h2 class="agileits-title w3title2">
              不懂
            </h2>
            <h4>不懂</h4>
            <p>不懂</p>
            <form
              action="#"
              method="post"
            >
              <div class="col-md-7 form-left">
                <select class="form-control">
                  <option>不懂</option>
                  <option>不懂</option>
                  <option>不懂</option>
                  <option>不懂</option>
                  <option>不懂</option>
                  <option>更多</option>
                </select>
              </div>


              <div class="col-md-5 make">
                <input
                  type="submit"
                  value="请选择"
                >
              </div>
              <div class="clearfix" />
            </form>
          </div>
          <div class="clearfix" />
        </div>
      </div>
    </div> -->
    <!-- //reservation -->
    <!-- team -->
     <br>
     <br>
     <br>
    <div class="clearfix" ></div>
    <section class="bar bg-gray no-mb padding-big text-md-center">
        <div style="  padding-right:230px;padding-left:250px; ">
          <div class="row   ">
            <div class="col-md-6  animate__animated animate__backInLeft animate__pulse  animation-duration: 2s" style="    margin-bottom: 6%;
    color: #686868;
    line-height: 1.8; font-family:  ui-sans-serif;">
              <h2 class="text-uppercase">太药控股集团有限公司</h2>
              <br>
              <p class="lead"  style="font-size:16px; float: left; text-align: left;  margin-bottom: 6%;
    color: #686868;
    line-height: 1.8;" >
                2021年10月，成立技术研发中心，引进了先进的原料药和制剂研究的小试、中试生产设备和检测仪器，每年投入不低于销售额10%的科研经费，与中北大学、山西医科大学、北京结核病诊疗技术创新联盟等科研机构合作，组建了33人年轻高水平的技术研发团队，短时间内攻克了多项技术瓶颈，2021年分别被省工信厅、省科技厅认定为省级技术中心和省级技术创新中心。
                同年12月，太药控股（山西）集团有限公司成立。
              </p>
              <p class="mb-small"></p>
              <p><router-link to="/about">更多</router-link>></p>
            </div>
            <div class="col-md-6   animate__animated text-center animate__backInRight animate__pulse  animation-duration: 2s"><img src="images/企业简介-太药控股集团.png" alt="" class="img-fluid"></div>
          </div>
        </div>
      </section>
    <!-- //team -->

   
    <div class="clearfix" ></div>

    <section class="bar bg-gray no-mb padding-big text-md-center">
    <news-view-vue></news-view-vue>
    </section>
    <div class="clearfix" ></div>
    <productType></productType>
    <div class="clearfix" ></div>
    <div class="clearfix" ></div>
    <!-- <section class="bar bg-gray no-mb padding-big text-md-center">
 
        <div class="row   ">
            <InnovationIndex></InnovationIndex>
          </div>
      
    </section> -->

    <!-- modal -->
    <div
      id="myModal"
      class="modal about-modal fade"
      tabindex="-1"
      role="dialog"
    >
    <div>
        <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span
                aria-hidden="true"
              >&times;</span>
            </button>
            <h4 class="modal-title">
                {{article.articleTitle}}
            </h4>
          </div>
          <div class="modal-body">
            <div class="agileits-w3layouts-info">
              <p>{{article.articleContent}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    <el-dialog
        top="75vh"
        modal="true"
        v-model="dialogVisible"
        width="500"
        height="500"
        show-close="true"
        :before-close="handleClose"
        style=" position: fixed; margin-bottom: 0px; bottom: 0; right: 0px; width:500px; height: 350px;"
      >
      <el-image src="images/tup.jpg"></el-image>
    </el-dialog>
  </div>
</template>
<style scoped>
    .bar.padding-big {
        padding: 50px 0;
    }
    .no-mb {
        margin-bottom: 0 !important;
    }
    .img-fluid {
      width: 500px;
    }

</style>
<script lang="js">
import { ElDialog, ElButton } from 'element-plus'
import IndexProducts from './IndexProducts.vue';
import bannerView from './BannerView.vue';
import * as  http from '@/request/http';
import newsViewVue   from './newsView.vue';
// import InnovationIndex from './InnovationIndex.vue'
 
import productType from './products/productType.vue'
export default {
  components: {
    // IndexProducts,
    bannerView,
    newsViewVue,
    // InnovationIndex,
 
    productType
   },
	name: 'HomeView',
  data() {
    return {
      dialogVisible: true,
      article: {}
    }
  },
  methods: {
    gotoDetail() {
      let  param = {
          newTitle: '关于太药',
          currentPage: 1,
          type:''
       }
      http.articles.articlelist(param).then(res=>{
           this.article=res.data.rows[0]
      })
    }
  },
	mounted() {
		const script = document.createElement('script');
		script.src = `/js/common.js`;
		script.onload = () => {
			console.log('myscript.js has been loaded');
		};
		document.head.appendChild(script);
	},
  created(){
    this.gotoDetail()
  }
};
</script>
 
